import { alpha } from '@mui/material/styles';

export const eventFailureTicketsStyles = {
  button: {
    borderColor: (theme) => alpha(theme.palette.warning.main, 0.7),
    bgcolor: (theme) => alpha(theme.palette.warning.main, 0.08),
    color: 'warning.dark',
    borderRadius: 1,
    fontWeight: 700,
    px: 1.75,
    whiteSpace: 'nowrap',
    textTransform: 'none',
    '&:hover': {
      borderColor: 'warning.main',
      bgcolor: (theme) => alpha(theme.palette.warning.main, 0.16),
    },
  },
  dialogTitle: {
    color: 'warning.dark',
    fontWeight: 700,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  contextPanel: {
    p: 2,
    borderRadius: 1,
    bgcolor: (theme) => alpha(theme.palette.warning.main, 0.04),
  },
  progressAlert: {
    alignItems: 'center',
  },
  summaryTile: {
    p: 1.5,
    borderRadius: 1,
    height: '100%',
  },
  resultsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    maxHeight: 260,
    overflowY: 'auto',
    pr: 0.5,
  },
  resultItem: {
    p: 1.25,
    borderRadius: 1,
    bgcolor: 'background.paper',
  },
  resultHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 1.5,
  },
  resultIdentity: {
    minWidth: 0,
  },
  resultMeta: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    gap: 1,
  },
  actionChip: {
    height: 22,
    fontSize: '0.72rem',
    fontWeight: 700,
    textTransform: 'capitalize',
  },
  ticketLink: {
    fontSize: '0.78rem',
    fontWeight: 700,
    whiteSpace: 'nowrap',
  },
  noTicket: {
    px: 0.75,
    py: 0.25,
    borderRadius: 1,
    bgcolor: 'grey.100',
    color: 'text.secondary',
    fontWeight: 700,
    whiteSpace: 'nowrap',
  },
  resultMessage: {
    mt: 0.75,
    color: 'text.primary',
  },
  errorReason: {
    display: 'block',
    mt: 0.5,
    color: 'error.main',
    fontWeight: 600,
  },
};
